import { useState } from 'react';
import imageEuropa from '../assets/destination/image-europa.webp';
import imageMars from '../assets/destination/image-mars.webp';
import imageMoon from '../assets/destination/image-moon.webp';
import imageTitan from '../assets/destination/image-titan.webp';
import '../style/Destination.css';

export default function Destination(){
    const listData = [
        {
            title: 'MOON',
            paragraph:`See our planet as you’ve never seen it before
            . A perfect relaxing trip away to help regain perspective
            and come back refreshed. While you’re there, take in
            some history by visiting the Luna 2 and Apollo 11 landing
            sites.`,
            avgDistance:'384,400 KM',
            estTravelTime:'3 DAYS',
            key:1,
            src: imageMoon,
        },
        {
            title: 'MARS',
            paragraph:`Don’t forget to pack your hiking boots. You’ll
            need them to tackle Olympus Mons, the tallest planetary mountain
            in our solar system. It’s two and a half times the size of Everest!`,
            avgDistance:'225 MIL. KM',
            estTravelTime:'9 MONTHS',
            key:2,
            src: imageMars,
        },
        {
            title: 'EUROPA',
            paragraph:`The smallest of the four Galilean moons orbiting Jupiter,
            Europa is a winter lover’s dream. With an icy surface, it’s perfect
            for a bit of ice skating, curling, hockey, or simple relaxation in your
            snug wintery cabin.`,
            avgDistance:'628 MIL. KM',
            estTravelTime:'3 YEARS',
            key:3,
            src: imageEuropa,
        },
        {
            title: 'TITAN',
            paragraph:`The only moon known to have a dense atmosphere other than
            Earth, Titan is a home away from home (just a few hundred degrees
            colder!). As a bonus, you get striking views of the Rings of Saturn.`,
            avgDistance:'1.6 BIL. KM',
            estTravelTime:'7 YEARS',
            key:4,
            src: imageTitan,
        },
    ]

    const [currentPlanet, setCurrentPlanet] = useState('MOON');
    const [data, setData] = useState(listData[0]);

    const navigationImage = (text) => {
        setCurrentPlanet(text)
        if(text === 'MOON'){
            setData(listData[0])
        }else if(text === 'MARS'){
            setData(listData[1])
        }else if(text === 'EUROPA'){
            setData(listData[2])
        }else{
            setData(listData[3])
        }
    }

    return (
        <div className='destination'>
            <div className='title'>
                <span>01</span>
                <p>PICK YOUR DESTINATION</p>
            </div>

            <div className='content-destination'>
                <div className='img-destination'>
                    {listData.map((list) =>  {
                            return <img className={currentPlanet === list.title ? 'current-img' : 'non-active'}
                            key={list.key} src={list.src} alt={'image' + list.title}/>
                    })}
                </div>

                <div className='text-destination'>
                    <ul>
                        {listData.map((list) =>  {
                            return <li className={currentPlanet === list.title ? 'activeNavigationPlanet' : ''}
                            key={list.key} onClick={navigationImage.bind(this, list.title)}>
                                {list.title}
                            </li>
                        })}
                    </ul>

                    <div className='title-destination'>
                        {listData.map((list) =>  {
                            return <h1 className={currentPlanet !== list.title ? 'non-active-title' : ''}
                            key={list.key}>{list.title}</h1>
                        })}
                    </div>

                    <p>{data.paragraph}</p>

                    <div className='info-text'>
                        <div>
                            <h3>AVG. DISTANCE</h3>
                            <p>{data.avgDistance}</p>
                        </div>
                        <div>
                            <h3>EST. TRAVEL TIME</h3>
                            <p>{data.estTravelTime}</p>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    )
}